 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		16: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		16: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"0681491c4b5bf8fcb49c3438a7dbfe60dad5e412","2":"98452909add1a39aecac74a3d52fb1474f194ce2","3":"6f1be029eb5bf84d2f61a0816234b270214c9097","4":"2c32dae14849a4f972874995451b6f57468ad597","5":"19e4762e47efd6488d785ad0a991ffddc017861b","6":"90f032246d4cdcf1d65eb1cf45f37ed8f593e782","7":"b840e4a0e0ec3abd82f448852459c0af2b1f0c75","8":"ebaf8b98baf70457351143e23dc397989aaef99e","9":"4a2c3bec25065dd2fdea912623f4dd70707c247a","10":"c6a2b77176a3bc3bec1b47526d84d42cd52f595b","11":"e9a0828a5d05114d8b38e47f15dd66585fc04534","12":"f54b42984bfe4d114461fcea2710af414ac1fe74","13":"framework","14":"3d413355dfb65eb506623c9bfd35aa5ed2abaf6f","15":"7490bd49aa53622910970b252a264e0dd9ced745","19":"component---src-pages-404-jsx","20":"component---src-pages-about-jsx","21":"component---src-pages-accessibility-index-jsx","22":"component---src-pages-accessibility-statement-jsx","23":"component---src-pages-accolades-jsx","24":"component---src-pages-alternative-index-jsx","25":"component---src-pages-black-friday-dear-manager-jsx","26":"component---src-pages-black-friday-index-active-jsx","27":"component---src-pages-black-friday-index-jsx","28":"component---src-pages-calculator-jsx","29":"component---src-pages-case-studies-jsx","30":"component---src-pages-color-contrast-jsx","31":"component---src-pages-create-workspace-jsx","32":"component---src-pages-css-3-d-transform-examples-index-jsx","33":"component---src-pages-css-specificity-calculator-jsx","34":"component---src-pages-dear-manager-jsx","35":"component---src-pages-disclaimer-jsx","36":"component---src-pages-docs-changelog-jsx","37":"component---src-pages-docs-faq-jsx","38":"component---src-pages-docs-index-jsx","39":"component---src-pages-docs-ui-overview-jsx","40":"component---src-pages-download-jsx","41":"component---src-pages-experimental-web-platform-features-jsx","42":"component---src-pages-exported-panes-jsx","43":"component---src-pages-github-students-jsx","44":"component---src-pages-index-jsx","45":"component---src-pages-integrations-index-jsx","46":"component---src-pages-integrations-jetbrains-webstorm-jsx","47":"component---src-pages-integrations-markerio-jsx","48":"component---src-pages-integrations-toybox-systems-jsx","49":"component---src-pages-integrations-tumult-hype-jsx","50":"component---src-pages-integrations-tumult-whisk-jsx","51":"component---src-pages-legal-jsx","52":"component---src-pages-newsletter-jsx","53":"component---src-pages-og-screenshot-jsx","54":"component---src-pages-opener-jsx","55":"component---src-pages-portal-index-jsx","56":"component---src-pages-pricing-jsx","57":"component---src-pages-privacy-jsx","58":"component---src-pages-product-tour-jsx","59":"component---src-pages-quality-assurance-index-jsx","60":"component---src-pages-resources-jsx","61":"component---src-pages-responsive-design-glossary-jsx","62":"component---src-pages-responsive-website-test-jsx","63":"component---src-pages-screenshot-comparison-jsx","64":"component---src-pages-site-quality-index-jsx","65":"component---src-pages-social-media-previews-index-jsx","66":"component---src-pages-special-offers-jsx","67":"component---src-pages-support-index-jsx","68":"component---src-pages-syntax-jsx","69":"component---src-pages-tailwindcss-jsx","70":"component---src-pages-testimonials-jsx","71":"component---src-pages-thanks-jsx","72":"component---src-pages-visualize-browser-sizes-jsx","73":"component---src-templates-blog-list-jsx","74":"component---src-templates-doc-jsx","75":"component---src-templates-post-jsx","76":"component---src-templates-term-jsx"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"d5a7fd7e873f86bcd173","2":"1e5eb309f92a0199b8b3","3":"8c0c607e947a0a5616be","4":"8a50615bc752d1273f48","5":"28d55d4abdeda5b65d3e","6":"d6580437a457e407a2c5","7":"1003434ce4ad3c159171","8":"32a4ee64833ed5fe8197","9":"ae0f1b8b7dc023d4685a","10":"f87247d128efa0619660","11":"99ced224b35a92bf44dd","12":"7926e00e6ed7fa314542","13":"0e9476df948b3672ca7a","14":"32659385fe4d6e8d0313","15":"26a01569192163f289a1","17":"ffdb6f2c66f858d94e86","19":"b4eb345fa91d7a08a210","20":"c94a2c093e5ad8412bbc","21":"2b1d7044924ecef52629","22":"eef801f03774a19d4d8d","23":"7b23b75f0f19649d0879","24":"8220c1ec81429ccc85df","25":"4970ec998c92737ff3ad","26":"e1c0d0da2a6e8dc39ac3","27":"4a23725112ead0b18a95","28":"b05ce281bbf426e05b9c","29":"9701c6a8ea1a6bea7080","30":"439fe17f1478fed8d59b","31":"3cda226269580d2c68dc","32":"48e3fb2910ff36c97af1","33":"3e4d26846adf5f52d1b2","34":"de559709992e72587690","35":"3e38991ddccecd8f76a5","36":"2c4cde631758cac04396","37":"872d3d79106a130a81c4","38":"3d48d90fc82d1d449d1c","39":"d68dc73d19b799a478b0","40":"2bf5c0d9500e3215fc53","41":"cc133393c466866db6c8","42":"c1b7c74646657d4b7818","43":"68b4971e587db98876e7","44":"5c7888c946512fdca39a","45":"3e60aeec945a2360c612","46":"ef4f74d0ccad849f750f","47":"036d5d413050d2854c53","48":"36827d66247b41dbc7f3","49":"f10df70e454acbb25667","50":"b2f0b1813a8076f891a0","51":"75aaa58ec7cba616b2af","52":"d55cf9bae542c668a74f","53":"4d001b6d12b3783e74af","54":"b2277bfe3f52b4094da9","55":"351ca802c8ce2124bc7a","56":"0c7530bcb05c48b72a4d","57":"21367247a163e0dd4907","58":"fa858c664d1697f780ec","59":"e3f78e7e426496a09345","60":"06503db0b4c6330b3dab","61":"f383f7a08149f3df5446","62":"2a3e7ecf460d96b37ca8","63":"bc92a3da5320a943a2a1","64":"d151837a03a7a388f5dc","65":"dca2989d34e5ac300149","66":"37f05f40572f282adc53","67":"5d8a21e928cce35785cf","68":"cca4589b693e34c3b13b","69":"37bd4e5d4231fc821d88","70":"1c4b29e2bac3833f7817","71":"ea3f9c2df1bf44581832","72":"fab55fc5e8db13d6598a","73":"a4d718f8cc5aa30c24d4","74":"a4b5f015b95de60123c0","75":"eaa7091375e335d589b4","76":"54ffef6b8cbfe9c3fec2","78":"3b4c4408e386d1efc740","79":"442f88552bbee3411063","80":"330fd865619df0f243e6","81":"213d2c5eabb3a6ba4ed7","82":"c60f94fb298bd86ce25a","83":"057cedc8928c2997d509","84":"9b0889230d11accb6d61","85":"39eb89b369b89771a4b8","86":"f93be4c3a9c56c4952af","87":"de60a41850573be0b35c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"0681491c4b5bf8fcb49c3438a7dbfe60dad5e412","2":"98452909add1a39aecac74a3d52fb1474f194ce2","3":"6f1be029eb5bf84d2f61a0816234b270214c9097","4":"2c32dae14849a4f972874995451b6f57468ad597","5":"19e4762e47efd6488d785ad0a991ffddc017861b","6":"90f032246d4cdcf1d65eb1cf45f37ed8f593e782","7":"b840e4a0e0ec3abd82f448852459c0af2b1f0c75","8":"ebaf8b98baf70457351143e23dc397989aaef99e","9":"4a2c3bec25065dd2fdea912623f4dd70707c247a","10":"c6a2b77176a3bc3bec1b47526d84d42cd52f595b","11":"e9a0828a5d05114d8b38e47f15dd66585fc04534","12":"f54b42984bfe4d114461fcea2710af414ac1fe74","13":"framework","14":"3d413355dfb65eb506623c9bfd35aa5ed2abaf6f","15":"7490bd49aa53622910970b252a264e0dd9ced745","19":"component---src-pages-404-jsx","20":"component---src-pages-about-jsx","21":"component---src-pages-accessibility-index-jsx","22":"component---src-pages-accessibility-statement-jsx","23":"component---src-pages-accolades-jsx","24":"component---src-pages-alternative-index-jsx","25":"component---src-pages-black-friday-dear-manager-jsx","26":"component---src-pages-black-friday-index-active-jsx","27":"component---src-pages-black-friday-index-jsx","28":"component---src-pages-calculator-jsx","29":"component---src-pages-case-studies-jsx","30":"component---src-pages-color-contrast-jsx","31":"component---src-pages-create-workspace-jsx","32":"component---src-pages-css-3-d-transform-examples-index-jsx","33":"component---src-pages-css-specificity-calculator-jsx","34":"component---src-pages-dear-manager-jsx","35":"component---src-pages-disclaimer-jsx","36":"component---src-pages-docs-changelog-jsx","37":"component---src-pages-docs-faq-jsx","38":"component---src-pages-docs-index-jsx","39":"component---src-pages-docs-ui-overview-jsx","40":"component---src-pages-download-jsx","41":"component---src-pages-experimental-web-platform-features-jsx","42":"component---src-pages-exported-panes-jsx","43":"component---src-pages-github-students-jsx","44":"component---src-pages-index-jsx","45":"component---src-pages-integrations-index-jsx","46":"component---src-pages-integrations-jetbrains-webstorm-jsx","47":"component---src-pages-integrations-markerio-jsx","48":"component---src-pages-integrations-toybox-systems-jsx","49":"component---src-pages-integrations-tumult-hype-jsx","50":"component---src-pages-integrations-tumult-whisk-jsx","51":"component---src-pages-legal-jsx","52":"component---src-pages-newsletter-jsx","53":"component---src-pages-og-screenshot-jsx","54":"component---src-pages-opener-jsx","55":"component---src-pages-portal-index-jsx","56":"component---src-pages-pricing-jsx","57":"component---src-pages-privacy-jsx","58":"component---src-pages-product-tour-jsx","59":"component---src-pages-quality-assurance-index-jsx","60":"component---src-pages-resources-jsx","61":"component---src-pages-responsive-design-glossary-jsx","62":"component---src-pages-responsive-website-test-jsx","63":"component---src-pages-screenshot-comparison-jsx","64":"component---src-pages-site-quality-index-jsx","65":"component---src-pages-social-media-previews-index-jsx","66":"component---src-pages-special-offers-jsx","67":"component---src-pages-support-index-jsx","68":"component---src-pages-syntax-jsx","69":"component---src-pages-tailwindcss-jsx","70":"component---src-pages-testimonials-jsx","71":"component---src-pages-thanks-jsx","72":"component---src-pages-visualize-browser-sizes-jsx","73":"component---src-templates-blog-list-jsx","74":"component---src-templates-doc-jsx","75":"component---src-templates-post-jsx","76":"component---src-templates-term-jsx"}[chunkId]||chunkId) + "." + {"0":"ab961b73b430d8e760c6","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c","76":"31d6cfe0d16ae931b73c","78":"31d6cfe0d16ae931b73c","79":"31d6cfe0d16ae931b73c","80":"31d6cfe0d16ae931b73c","81":"31d6cfe0d16ae931b73c","82":"31d6cfe0d16ae931b73c","83":"31d6cfe0d16ae931b73c","84":"31d6cfe0d16ae931b73c","85":"31d6cfe0d16ae931b73c","86":"31d6cfe0d16ae931b73c","87":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
